import React from 'react';

import { Icon } from './Icon.tsx';

const NativeButton = 'button';

export interface SubtabConfig {
    id: string;
    label: string;
    icon?: string; // Material icon name
}

interface SubtabSwitcherProps {
    tabs: readonly SubtabConfig[];
    activeTab: string;
    onChange: (tabId: string) => void;
    ariaLabel?: string;
    className?: string;
}

export const SubtabSwitcher: React.FC<SubtabSwitcherProps> = ({ tabs, activeTab, onChange, ariaLabel, className = '' }) => {
    const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
        if (e.key === 'ArrowLeft' && index > 0) {
            onChange(tabs[index - 1]!.id);
        } else if (e.key === 'ArrowRight' && index < tabs.length - 1) {
            onChange(tabs[index + 1]!.id);
        }

    };

    return (
        <div className={`mb-4 border-gray-200 border-b dark:border-border-dark ${className}`} role="tablist" aria-label={ariaLabel}>
            <div className="flex flex-wrap gap-1">
                {tabs.map((tab, index) => {
                    const isActive = activeTab === tab.id;
                    return (
                        <NativeButton
                            type="button"
                            key={tab.id}
                            id={`${tab.id}-tab`}
                            role="tab"
                            aria-selected={isActive}
                            aria-controls={`${tab.id}-panel`}
                            onClick={() => onChange(tab.id)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className={`min-h-[44px] border-b-2 px-4 py-2.5 font-medium text-sm transition-all ${isActive
                                    ? 'border-primary bg-primary/10 text-primary dark:bg-primary/20'
                                    : 'border-transparent text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-gray-200'
                                }
                            `}
                        >
                            <div className="flex items-center gap-2">
                                {tab.icon ? <Icon name={tab.icon} size="sm" /> : null}
                                {tab.label}
                            </div>
                        </NativeButton>
                    );
                })}
            </div>
        </div>
    );
};













